export const EMAIL_TYPE = 'email';
export const PASSWORD_TYPE = 'password';
export const ERROR_TYPE = 'error';
export const WARNING_TYPE = 'warning';
export const FLOW_FREE_TRIAL = 'FLOW_FREE_TRIAL';
export const FLOW_FREE_TRIAL_ONLY_US = 'FLOW_FREE_TRIAL_ONLY_US';
